import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Page, Card, DataTable, AppProvider, Link, Button, ButtonGroup, ResourceList, Badge, Select, Checkbox, Pagination, Spinner } from '@shopify/polaris';
import FilterTableProvider from '@container/FilterTableProvider';

import { sellerApplicationFormColumns } from 'utils/recordHelpers'

const propTypes = {
  records: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  filterURL:  PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
};

const SectionIndex = (props) => {
  return (
    <FilterTableProvider
      pageProps={{
        title: I18n.t("activerecord.models.seller_application_form.other"),
      }}
      paramsName="filters"
      filterURL={ props.filterURL }
      itemURL="/seller_application_forms"
      tabs={ props.tabs }

      initialRecords={ props.records }
      columnsInfo={ sellerApplicationFormColumns }
      
      initialTotalPages={ props.totalPages }
      legacy={ false }
    >
    </FilterTableProvider>
  );
}

SectionIndex.propTypes = propTypes;


export default SectionIndex;
